export const inAppintegration = {
  GOOGLE_IN_APP_INTEGRATION: 'v2/hooks/google-in-app/setup',
  ADD_IN_APP_INTEGRATION: 'v2/payments/providers/metadata',
  IN_APP_INTEGRATION: 'v2/payments/providers/metadata/{id}',
  // Admin Panel
  LOAD_APPLE_IN_APP_INTEGRATION: 'v2/payments/providers/metadata/{paymentProviderId}',
};
